import VueCookies from "vue-cookies";
import {
  claimsFromTokenPayload,
  isAdminFromTokenPayload,
  parseJwtPayload,
  userFromTokenPayload,
} from "../../../utils/authToken";

let isAdmin = false;
let claims = "";
let user = "";
let branch = "";
let name = "";
let emailAddress = "";
let utaPhone = "";
let plivoPhone = "";

const token = VueCookies.get("user-token");
if (token != null) {
  const tokenPayload = parseJwtPayload(token);
  if (tokenPayload) {
    isAdmin = isAdminFromTokenPayload(tokenPayload);
    claims = claimsFromTokenPayload(tokenPayload);
    user = userFromTokenPayload(tokenPayload);
    branch = tokenPayload.branch || "";
    emailAddress = tokenPayload.emailAddress || "";
    name = tokenPayload.name || "";
    utaPhone = tokenPayload.utaPhone || "";
    plivoPhone = tokenPayload.plivoPhone || "";
  }
}
export default {
  token: token || "",
  roles: localStorage.getItem("user-roles") || "",
  status: "",
  user: user || "",
  claims: claims || "",
  isAdmin: isAdmin || false,
  utaPhone: utaPhone || "",
  name: name || "",
  branch: branch || "",
  plivoPhone: plivoPhone || "",
  emailAddress: emailAddress || "",
};
